export function SessionHeader({ session }) {
    return (
        <div className="header">
            <h1>Session {session.sessionCode}</h1>
            <h2>
                {session.isActive ? "Voting Open" : "Voting Closed"}
            </h2>
        </div>
    );
}
